import Vue from 'vue';
import billTransformer from './../../transformers/bill';

const success = (resolve, response) => {
  if (response.data.data) {
    const result = {
      errors: response.data.errors,
      data: billTransformer.fetchCollection(response.data.data),
    };
    resolve(result);
  } else {
    resolve(billTransformer.fetch(response.data));
  }
};

const failed = (errors, reject) => {
  if (errors.error) {
    reject(errors.error);
    return;
  }

  reject(billTransformer.fetch(errors));
};

export default bill => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post('/bills', bill)
      .then((response) => {
        success(resolve, response);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/bill/store.js